var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isTopTipShow)?_c('div',{attrs:{"id":"layout-top-tip"}},[_c('span',[_vm._v("您当前网站即将在2021-05-08到期，请及时续费！")]),_c('a',{attrs:{"href":""}},[_vm._v("立即续费")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }